<template>
	<v-container fluid fill-height class="container-bg">
		<v-layout justify-center align-center>
			<v-flex xs12 sm8 md4>
				<v-card
					:class="{ 'pa-4': isSmallScreen, 'pa-5': !isSmallScreen }"
				>
					<h5 class="mb-4 headline hidden-xs-only">
						Enter Login Details
					</h5>
					<h6 class="mb-4 title hidden-sm-and-up">
						Enter Login Details
					</h6>
					<v-form
						v-model="formIsValid"
						ref="loginForm"
						@submit.prevent
					>
						<v-layout row wrap class="mb-3">
							<v-flex xs12 class="mb-2">
								<v-text-field
									v-model="username"
									:rules="[requiredRule]"
									prepend-icon="person"
									:color="themeColor"
									label="Username"
									required
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="password"
									@keyup.enter="tryLogIn"
									type="password"
									:rules="[requiredRule]"
									prepend-icon="lock"
									:color="themeColor"
									label="Password"
									required
								></v-text-field>
							</v-flex>
						</v-layout>
						<v-btn
							large
							:disabled="!formIsValid"
							@click="tryLogIn"
							:loading="tryingSignIn"
							:color="themeColor"
							class="full-width white--text ml-0"
							>Log in</v-btn
						>
					</v-form>
				</v-card>
			</v-flex>
		</v-layout>
		<v-snackbar bottom right v-model="alert.show">{{
			alert.text
		}}</v-snackbar>
	</v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import * as utils from "@/utils";
import { USER_SIGN_IN } from "@/store/action-types";

export default {
	name: "AdminLogin",
	data() {
		return {
			formIsValid: false,
			requiredRule: v => !!v || "This is required",
			username: "",
			password: "",
			themeColor: utils.themeInputColor,
			tryingSignIn: false
		};
	},
	computed: {
		...mapState({
			alert: state => state.common.alert,
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN
		}),
		...mapGetters({
			isRetailAdmin: "auth/isRetailAdmin",
			isRetailer: "auth/isRetailer",
			isFinanceAdmin: "auth/isFinanceAdmin"
		}),
		isSmallScreen() {
			let screen_size = this.$vuetify.breakpoint.name;
			return screen_size === "xs" || screen_size === "sm";
		}
	},
	created() {
		if (this.ACCESS_TOKEN) {
			this.$router.replace("/");
		}
	},
	methods: {
		tryLogIn() {
			if (!this.tryingSignIn) {
				this.tryingSignIn = true;
				this.$store
					.dispatch(USER_SIGN_IN.dispatch, {
						username: this.username,
						password: this.password,
						toolName: "retailAdmin"
					})
					.catch(() => {})
					.then(() => {
						this.tryingSignIn = false;
					});
			}
		}
	},
	watch: {
		ACCESS_TOKEN(newValue) {
			if (newValue) {
				if (this.isFinanceAdmin) {
					this.$router.replace("/acknowledge");
				} else {
					this.$router.replace("/review");
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.container-bg {
	background: linear-gradient(160deg, #42a5f5, #1565c0);
}
</style>
